module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAYAAABWzo5XAAAAAXNSR0IArs4c6QAAAU5JREFUOE+1lN1VwkAQRu+kAjoQKjB2sFYgViAB340d2IH4riRWIFTAdhCswNgBFex4siwrIXqOP7BvezJ755tvZiIc6MiBOBwfZArtoVwg9L1qpUZY2EzWX1XRUeQBcIOSo7wj2AAyCCcIU+BhH9gCBRVLFCEht5lsIOGYQg2OKeIjzndhERQh8Ip4yNoU2pR1FTjPNpM6xJXg1UXYJ2imJUpqJ5I2D02hKcoSWITShiSkDcx/f9IVUNmJZM3dg8yjDhHKVuBMGy96diwjH7NJVNuJ3IVEfRwrlJG9lvn/QEqFI4ugmBFO7VjOWhnhJXh02SlNWG0Vt812vtUVCbfRbIcvjYQymu0ogAEJZtu5bvsb2Ka9DazbfuU+jEeERLP3ZqWHIwdyhDc0DKRgUAbAdGv47rtvd83Pi2MIYUWgJmH+4xX569/g+Nv/W2UfSLizE0ZcB4YAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/modbus3.png
// module id = C47l
// module chunks = 5